import { FC } from "react";
import { Box, Picture } from "@smile2impress/components/relaunch";

import { LargePictureProps } from "./LargePicture.types";

export const LargePicture: FC<LargePictureProps> = ({ content }) => {
    const { image } = content;

    return (
        <Box width="100%" h={10}>
            <Picture {...image} width="100%" />
        </Box>
    );
};
